import { useEffect } from 'react';
import { useSipWebsocket } from 'app/protocol/SipWebsocketProvider';
import Command from 'app/protocol/Command';

function StreamDataParser(props) {
	const { message } = useSipWebsocket();

	useEffect(() => {
		if (props.running && message instanceof Command) {
			if (message.command === Command.STREAMING_DATA_PACKET) {
				if (message.sensorDataBuffer.length > 0) {
					console.log(`sensorDataBuffer size: ${message.sensorDataBuffer.length}`);
					props.handleData(message.sensorDataBuffer[0]);
				}
			} else if (message.command === Command.STREAMING_TYPE_PACKET) {
				props.handleTypes(message.sensorTypes);
			}
		}
	}, [message]);

	return <></>;
}

export default StreamDataParser;
